import { GoUnverified, GoVerified } from "react-icons/go";

const ThankYouPage = ({ title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen gap-4">
      <div className="flex flex-col items-center justify-center h-full gap-8">
        <GoVerified
          size={160}
          className="text-white bg-green-400 p-4 rounded-full"
        />
        <div className="text-3xl text-center font-semibold">
          {title || "Thank you for signing the agreement!"}
        </div>
        <div className="text-xl text-center">
          {description || "Your consent has been successfully submitted."}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
